import angular from 'angular';

angular.module('cloudX').component('cxVatRateTypeSelect', {
  bindings: {
    vatRate: '<',
    vatType: '<',
    onChange: '&',
    disabled: '<',
    inputClass: '@',
  },
  controller: [
    '$scope',
    'optionsSvc',
    'enumCacheSvc',
    function($scope, optionsSvc, enumCacheSvc) {
      const ctrl = this;
      ctrl.vatTypes = [];
      ctrl.internalValue = '';
      ctrl.percentages = optionsSvc.getOptions('vatPercentage');
      enumCacheSvc.get('vatType').then(data => {
        ctrl.vatTypes = data.filter(x => x.key !== 0);
      });

      ctrl.setInternalValue = function() {
        if (ctrl.vatType === null || ctrl.vatRate === null) {
          this.internalValue = null;
          return;
        }
        let vatType = ctrl.vatType;
        if (ctrl.vatRate > 0) vatType = 0;
        let vatRate = '0';
        if (vatType === 0) {
          const vat = ctrl.percentages.find(x => x.value === ctrl.vatRate);
          if (vat) vatRate = vat.label;
        }
        ctrl.internalValue = `${vatType};${vatRate}`;
      };
      ctrl.save = function() {
        if (!ctrl.internalValue) {
          ctrl.onChange({ vatRate: null, vatType: null });
          return;
        }
        const [type, vat] = ctrl.internalValue.split(';');
        let vatType = parseInt(type);
        let vatRate = 0;
        if (vatType === 0) {
          const percentage = ctrl.percentages.find(x => x.label === vat);
          if (percentage) vatRate = percentage.value;
        }
        ctrl.onChange({ vatRate, vatType });
      };

      ctrl.$onChanges = function() {
        ctrl.setInternalValue();
      };
    },
  ],
  template: `<select ng-model="$ctrl.internalValue" ng-change="$ctrl.save()" class="form-control" ng-class="$ctrl.inputClass" ng-disabled="$ctrl.disabled">
  <option ng-show="!$ctrl.internalValue" data-translate value="">Set a percentage</option>
  <option ng-repeat="p in $ctrl.percentages track by p.value" value="0;{{p.label}}" ng-bind="p.value|percentage:0"></option>
  <option ng-repeat="t in $ctrl.vatTypes track by t.key" value="{{t.key}};0">{{t.key |translateList:'vatType':t.name}}</option>
</select>`,
});
